import { io } from 'socket.io-client';

class WebSocketService {
  socket = null;
  options = {};

  connect(url, options = {}) {
    this.options = options;
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
    this.socket = io(url, {
      auth: { token: sessionStorage.getItem('token') || undefined },
      autoConnect: true,
      transports: ['websocket'],
    });
    this.socket.on('connect', () => {
      options.onConnect && options.onConnect();
    });
    this.socket.on('disconnect', () => {
      options.onDisconnect && options.onDisconnect();
    });
    this.socket.on('message', (evt) => {
      if (evt.type === 'message') {
        options.onMessage && options.onMessage(evt.role, evt.content, evt.metadata);
      }
    });
    this.socket.on('audio', (evt) => {
      if (evt.type === 'audio') {
        options.onAudio && options.onAudio(evt.url);
      }
    });
    this.socket.on('listening_start', (evt) => {
      if (evt.type === 'listening_start') {
        options.onListeningStart && options.onListeningStart();
      }
    });
    this.socket.on('listening_end', (evt) => {
      if (evt.type === 'listening_end') {
        options.onListeningEnd && options.onListeningEnd(evt.transcript);
      }
    });
    this.socket.on('error', (err) => {
      const message = typeof err === 'string' ? err : (err.message || 'Unknown socket error');
      options.onError && options.onError(message);
    });
  }

  disconnect() {
    if (this.socket) this.socket.disconnect();
    this.socket = null;
  }

  isConnected() {
    return !!this.socket && this.socket.connected;
  }

  sendMessage(text, convId) {
    if (!this.socket) return;
    const evt = {
      type: 'message',
      convId,
      role: 'user',
      content: [{ type: 'text', value: text }],
    };
    this.socket.emit('message', evt);
  }

  requestAudio(url, convId) {
    if (!this.socket) return;
    const evt = { type: 'request_audio', convId, url };
    this.socket.emit('request_audio', evt);
  }

  startListening(convId) {
    if (!this.socket) return;
    const evt = { type: 'listening_start', convId };
    this.socket.emit('listening_start', evt);
  }

  stopListening(convId) {
    if (!this.socket) return;
    const evt = { type: 'listening_end', convId, transcript: '' };
    this.socket.emit('listening_end', evt);
  }

  joinRoom(convId) {
    if (!this.socket) return;
    console.log('[WebSocketService] Joining room:', convId);
    this.socket.emit('connectRoom', { convId });
  }

  sendAudio(audioBlob, convId) {
    if (!this.socket) return;
    const reader = new FileReader();
    reader.onload = () => {
      const arrayBuffer = reader.result;
      this.socket.emit('audio', { convId, audio: Array.from(new Uint8Array(arrayBuffer)) });
    };
    reader.readAsArrayBuffer(audioBlob);
  }
}

export const socketService = new WebSocketService(); 